import React, { useMemo } from 'react'
import { DateCalendar, DateCalendarProps } from 'transfix-ui/core/pickers'
import { IDatePickerProps } from '../DatePicker'
import { TDateFormat } from '../DatePicker/types'
import { getParsedValue } from '../DatePicker/utils/getParsedValue'

export interface ICalendarProps
  extends Omit<DateCalendarProps<TDateFormat>, 'disableToolbar' | 'variant'> {
  dataTest?: string
}

const dayOfWeekFormatter: IDatePickerProps['dayOfWeekFormatter'] = day => {
  return day.slice(0, 3)
}

export const Calendar = ({
  dataTest,
  value: valueProp,
  views = ['day'],
  minDate: minDateProp,
  maxDate: maxDateProp,
  ...props
}: ICalendarProps) => {
  const value = useMemo(() => getParsedValue(valueProp), [valueProp])
  const minDate = useMemo(() => getParsedValue(minDateProp), [minDateProp])
  const maxDate = useMemo(() => getParsedValue(maxDateProp), [maxDateProp])
  return (
    <DateCalendar
      data-test={dataTest}
      views={views}
      value={value}
      minDate={minDate}
      maxDate={maxDate}
      dayOfWeekFormatter={dayOfWeekFormatter}
      {...props}
    />
  )
}

export default Calendar
